import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Api from "services/api"


export const initialState = {
  mainAccountProfile: [],
  error: null,
  loader: false,
}

export const mainAccountProfileSlice = createSlice({
  name: 'mainAccountProfile',
  initialState: initialState,
  reducers: {
    setMainAccountProfile: (state, { payload }) => {
      state.mainAccountProfile = payload?.data ?? payload;
    },
    setMainAccountProfiles: (state, { payload }) => {
      state.mainAccountProfile = payload?.data;
    },
    removeMainAccountProfile: (state, { payload }) => {
      state.error = payload
    },
    clearAllMainAccountProfile: (state, { payload }) => {
      state.loader = payload
    },
    setError: (state, { payload }) => {
      state.error = payload
    },
    setLoader: (state, { payload }) => {
      state.loader = payload
    },
  }
})


export const fetchMainAccountProfile = (data) => async (dispatch) => {
    const apiService = new Api();
    dispatch(setError({}))
    dispatch(setLoader(true))
    try {
  
      const json = await Api.fetchMainAccountProfile(data)
      if (json.status >= 200 && json.status < 300) {
        dispatch(setMainAccountProfiles(json.data))
        // callback(true, json.data.message)
        dispatch(setLoader(false))
      } else if (json.status == 422) {
        dispatch(setError(json.data))
        // callback(false, json.data.message)
        dispatch(setLoader(false))
      }else{
        dispatch(setLoader(false))
      }
    } catch (error) {
      console.log(error)
      dispatch(setLoader(false))
      // callback(false)
    }
  }
  
export const updateMainAccountProfile = (data, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.updateMainAccountProfile(data)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setType(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}


// export const changePassword = (data, callback) => async (dispatch) => {
//     const apiService = new Api();
//     dispatch(setError({}))
//     dispatch(setLoader(true))
//     try {
  
//       const json = await Api.changePassword(data)
//       if (json.status >= 200 && json.status < 300) {
//         callback(true, json.data.message)
//       } else if (json.status == 422) {
//         dispatch(setError(json.data))
//         callback(false, json.data.message)
//       }
//     } catch (error) {
//       console.log(error)
//       // callback(false)
  
//     }
//     dispatch(setLoader(false))
//   }


export const { setMainAccountProfile, setMainAccountProfiles, clearAllMainAccountProfile, setLoader, setError, setMoreMainAccountProfiles } = mainAccountProfileSlice.actions


export default mainAccountProfileSlice.reducer
export const mainAccountProfileSelector = state => state.mainAccountProfile


